export default __webpack_public_path__ + "static/media/Tech Visa - Overview.f3ac8464.jpg";